import {Directive, HostBinding, input} from '@angular/core';
import moment from 'moment';

/**
 * This directive helps to draw a horizontal rectangle to display a timeslot.
 */
@Directive({
  selector: '[appHorizontalTimeSlot]',
})
export class HorizontalTimeSlotDirective {

  /**
   * The earliest time in a grid.
   */
  readonly gridStart = input<string>(undefined);
  /**
   * Start time of an assigment.
   */
  readonly startTime = input<string>(undefined);
  /**
   * End time of an assignment.
   */
  readonly endTime = input<string>(undefined);
  /**
   * Width of one cell in a grid (pixels).
   */
  readonly cellWidth = input<number>(undefined);

  /**
   * Calculates how many pixels from the left side should be the start of a rectangle.
   */
  @HostBinding('style.left.px')
  get left(): number {
    return this.getLeft();
  }

  /**
   * Calculates the width of a rectangle in pixels.
   */
  @HostBinding('style.width.px')
  get width(): number {
    return this.getWidth();
  }

  private getLeft(): number {
    const diff = this.getDiffInMinutes(this.gridStart(), this.startTime());
    return diff / 60 * this.cellWidth();
  }

  private getWidth(): number {
    const diff = this.getDiffInMinutes(this.startTime(), this.endTime());
    return diff / 60 * this.cellWidth();
  }

  private getDiffInMinutes(startTime: string, endTime: string) {
    const momentStartTime = moment(startTime, 'HH:mm');
    const momentEndTime = moment(endTime, 'HH:mm');
    return momentEndTime.diff(momentStartTime, 'minutes');
  }
}
